import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { ReactElement } from 'react'
import { TableComponent } from '../../comps/TableComponent'
import { splitDetailsHeaderData } from '../../data/static/data'
import { useWindowDimensions } from '../../util/util'
import { styles } from './styles'

interface DataType {
  id: string
  value: string | number
}

const getItemView = (obj: DataType, themes: any, index: number): ReactElement => {
  let style = { ...themes.listItemText }
  return (
    <Box f={1}>
      <TextNew testID={`${obj.id}${index}`} {...style}>
        {obj.value.toString()}
      </TextNew>
    </Box>
  )
}

const renderItem = (item, themes): ReactElement => {
  const listData: any = Object.entries(item?.item).map((element) => ({
    id: element[0],
    value: element[1],
  }))
  const listItems = listData.map((obj: any) => getItemView(obj, themes, item?.index))
  return <Box {...themes.listItemContainer}>{listItems}</Box>
}

const getheaderView = (obj: DataType, themes: any): ReactElement => {
  let style = themes.hoverHeaderText
  if (obj.id === 'rrn') {
    style = { ...themes.hoverHeaderText, width: 150 }
  }
  return (
    <Box f={1}>
      <TextNew type="body12" fontWeight="BOLD" {...style}>
        {obj.value.toString()}
      </TextNew>
    </Box>
  )
}

const renderHeader = (themes: any): ReactElement => {
  const listData: DataType[] = Object.entries(splitDetailsHeaderData).map((element) => ({
    id: element[0],
    value: element[1],
  }))
  const headerItems = listData.map((obj) => getheaderView(obj, themes))
  return <Box {...themes.listHeaderContainer}>{headerItems}</Box>
}

const SplitSettlementDetails = ({ data }) => {
  const viewPortWidth = useWindowDimensions()

  const themes = styles(viewPortWidth)

  const renderListItem = (item: any, index: number): ReactElement => {
    return renderItem(item, themes)
  }

  const renderHeaderItem = (): ReactElement => {
    return renderHeader(themes)
  }

  return (
    <Box {...themes.detailsContainer}>
      <TextNew fontFamily={'jiotype-bold'} fontWeight="bold">
        {'Split Details'}
      </TextNew>
      <Spacer size={16} />
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={data}
        hide={false}
        contentContainerStyle={themes.list}
        isCustom={true}
        RenderCustomElement={renderListItem}
        ListHeaderComponent={renderHeaderItem}
      />
    </Box>
  )
}

export default SplitSettlementDetails
